/**
 * JourneySteps — the 3-step tester journey, shown on the public landing page
 * under the hero (story epic-uat-portal-001-9).
 *
 * The journey is: Read the guide → Capture details → File it here. It states up
 * front that Discord is not required — this portal is the way (design goal 6,
 * "Retire Discord"; the portal is the front door of the tester journey).
 *
 * Public: renders for anyone with the link, no account needed.
 */

const STEPS = [
  {
    n: 1,
    title: 'Read the guide',
    body: 'Pick a walkthrough below and follow it click-by-click. Each one points you at the right staging app and tells you exactly what to try.',
  },
  {
    n: 2,
    title: 'Capture the details',
    body: 'When something looks off, grab the proof before you move on — the page address, a screenshot, and any red errors. The how-to lower down shows you how.',
  },
  {
    n: 3,
    title: 'File it here',
    body: 'Sign in with your invite and file the report on this portal. You can also see everything else that has been reported, so you know what is already known.',
  },
];

export function JourneySteps() {
  return (
    <section
      aria-labelledby="journey-heading"
      data-testid="journey-steps"
      className="mx-auto w-full max-w-4xl px-6 py-12"
    >
      <h2 id="journey-heading" className="mb-2 text-2xl font-bold">
        How testing works
      </h2>
      <p
        className="mb-8 text-sm text-muted-foreground"
        data-testid="journey-no-discord"
      >
        You don&apos;t need Discord. This portal is the way — the guides, the
        report form, and the status of everything filed all live here.
      </p>

      <ol className="grid gap-6 sm:grid-cols-3">
        {STEPS.map((step) => (
          <li
            key={step.n}
            data-testid={`journey-step-${step.n}`}
            className="rounded-lg border border-gray-200 p-5"
          >
            <div className="mb-3 flex h-8 w-8 items-center justify-center rounded-full bg-green-600 font-bold text-white">
              {step.n}
            </div>
            <h3 className="mb-1 font-semibold">{step.title}</h3>
            <p className="text-sm text-muted-foreground">{step.body}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
